<div class="w-full flex flex-col flex-1 min-h-0">
  <div class="flex flex-col flex-1 min-h-0 overflow-hidden">
    <div class="flex-1 min-h-0 flex flex-col bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden">
      <div class="px-6 py-5 border-b border-slate-200 bg-slate-50/50 shrink-0">
        <div class="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-4">
          <div>
            <h2 class="text-lg font-semibold text-slate-900 flex items-center gap-2">
              <span class="flex h-9 w-9 items-center justify-center rounded-lg bg-sky-100 text-sky-600">
                <i class="pi pi-wallet"></i>
              </span>
              Conciliación bancaria
            </h2>
            <p class="text-sm text-slate-500 mt-1">Recibos y liquidaciones de Pento del periodo, con o sin pago. Los conciliados siguen visibles.</p>
          </div>
          <div class="flex flex-wrap items-end gap-3">
            <p-button label="Importar CSV" icon="pi pi-upload" size="small" [rounded]="true" (onClick)="openImportDialog()" *appHasPermission="'BANK_RECONCILIATION_WRITE'" />
            <p-button label="Ejecutar matching" icon="pi pi-bolt" size="small" [rounded]="true" [loading]="matching()" (onClick)="openMatchDialog()" *appHasPermission="'BANK_RECONCILIATION_WRITE'" />
          </div>
        </div>
      </div>

      <div [formGroup]="filterForm" class="border-b border-slate-200 bg-slate-50 shrink-0 px-3 py-2">
        <div class="flex flex-wrap items-end gap-2">
          <p-floatlabel class="w-full min-w-0 sm:w-72" variant="on">
            <p-datepicker
              inputId="filterPaidAtRange"
              formControlName="paidAtRange"
              selectionMode="range"
              [readonlyInput]="true"
              dateFormat="dd/mm/yy"
              showIcon
              iconDisplay="input"
              [showClear]="true"
              size="small"
              appendTo="body"
              class="w-full" />
            <label for="filterPaidAtRange">Periodo a conciliar</label>
          </p-floatlabel>
          <p-button label="Hoy" size="small" [rounded]="true" [severity]="activePreset() === 'today' ? 'primary' : 'secondary'" (onClick)="applyPreset('today')" />
          <p-button label="Última semana" size="small" [rounded]="true" [severity]="activePreset() === 'week' ? 'primary' : 'secondary'" (onClick)="applyPreset('week')" />
          <p-button label="Último mes" size="small" [rounded]="true" [severity]="activePreset() === 'month' ? 'primary' : 'secondary'" (onClick)="applyPreset('month')" />
          <p-button label="Último bimestre" size="small" [rounded]="true" [severity]="activePreset() === 'bimester' ? 'primary' : 'secondary'" (onClick)="applyPreset('bimester')" />
          <p-button label="Último semestre" size="small" [rounded]="true" [severity]="activePreset() === 'semester' ? 'primary' : 'secondary'" (onClick)="applyPreset('semester')" />
          <p-button label="Último año" size="small" [rounded]="true" [severity]="activePreset() === 'year' ? 'primary' : 'secondary'" (onClick)="applyPreset('year')" />
          <div class="flex items-center gap-2 pb-1">
            <p-checkbox
              inputId="showMatched"
              [binary]="true"
              [ngModel]="showMatched()"
              [ngModelOptions]="{ standalone: true }"
              (ngModelChange)="onShowMatchedChange($event)" />
            <label for="showMatched" class="text-sm text-slate-700 cursor-pointer">Mostrar emparejados</label>
          </div>
        </div>
      </div>

      <div class="flex-1 min-h-0 overflow-hidden">
        <p-table
          [value]="inbox()"
          [loading]="loading()"
          dataKey="id"
          [scrollable]="true"
          scrollHeight="flex"
          [rowHover]="true"
          styleClass="bank-inbox-table p-datatable-striped p-datatable-sm"
        >
          <ng-template pTemplate="header">
            <tr>
              <th>Tipo</th>
              <th>Estado</th>
              <th class="text-center">Fecha</th>
              <th class="text-right">Monto</th>
              <th class="hidden sm:table-cell">Referencia</th>
              <th></th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-row>
            <tr
              class="cursor-pointer"
              [class.bg-sky-50]="selectedItem()?.id === row.id && selectedItem()?.kind === row.kind && matchDrawer()"
              (click)="openMatchDrawer(row)"
            >
              <td>
                <div class="flex items-center gap-2">
                  <span class="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-slate-100 text-slate-600">
                    <i class="pi" [ngClass]="row.kind === 'SETTLEMENT' ? 'pi-building-columns' : 'pi-wallet'"></i>
                  </span>
                  @if (row.kind === 'CHARGE' && row.id != null) {
                    <button
                      type="button"
                      class="text-left text-sm font-medium text-sky-700 hover:underline"
                      (click)="openChargeRead(row, $event)">
                      {{ kindLabel(row.kind) }}
                    </button>
                  } @else {
                    {{ kindLabel(row.kind) }}
                  }
                </div>
              </td>
              <td>
                <div class="flex flex-wrap items-center gap-1">
                  <p-tag class="!text-xs" [severity]="statusSeverity(row)" [value]="statusLabel(row)" />
                  @if (row.kind === 'CHARGE' && row.paid === false) {
                    <p-tag class="!text-xs" severity="warn" value="Sin pago" />
                  }
                </div>
              </td>
              <td class="text-center whitespace-nowrap">{{ row.date }}</td>
              <td class="text-right">{{ row.amount | currency:'MXN':'symbol-narrow' }}</td>
              <td class="hidden sm:table-cell">{{ row.label }}</td>
              <td class="text-right" (click)="$event.stopPropagation()">
                @if (row.matched) {
                  <p-button
                    label="Desemparejar"
                    size="small"
                    severity="warn"
                    [loading]="isBusy(rowKey(row))"
                    (onClick)="reverseItem(row)"
                    *appHasPermission="'BANK_RECONCILIATION_WRITE'" />
                } @else {
                  <p-button
                    label="Conciliar"
                    size="small"
                    (onClick)="openMatchDrawer(row)"
                    *appHasPermission="'BANK_RECONCILIATION_WRITE'" />
                }
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="6" class="text-center text-slate-500 py-8">No hay recibos ni liquidaciones en este periodo.</td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>
</div>

<p-drawer
  [visible]="matchDrawer()"
  (visibleChange)="onMatchDrawerVisibleChange($event)"
  position="right"
  styleClass="bank-match-drawer"
  [style]="{ width: 'min(78rem, calc(100vw - 1.5rem))' }"
  [blockScroll]="true"
>
  <ng-template pTemplate="header">
    <div class="flex items-center gap-2 w-full min-w-0">
      <span class="flex h-7 w-7 shrink-0 items-center justify-center rounded-lg bg-sky-100 text-sky-600 text-sm">
        <i class="pi" [ngClass]="selectedItem()?.kind === 'SETTLEMENT' ? 'pi-building-columns' : 'pi-wallet'"></i>
      </span>
      <div class="min-w-0">
        <h3 class="text-sm font-semibold text-slate-900">
          {{ selectedItem()?.matched ? 'Ya conciliado' : ('Conciliar ' + kindLabel(selectedItem()?.kind)) }}
        </h3>
        <p class="text-xs text-slate-500">
          {{ selectedItem()?.matched ? 'Este movimiento ya fue emparejado.' : 'Elige un abono del estado de cuenta' }}
        </p>
      </div>
    </div>
  </ng-template>

  <div class="flex flex-col h-full min-h-0 gap-2 text-xs">
    <section class="shrink-0 rounded-xl border border-slate-200 bg-white p-3 shadow-sm">
      @if (matchDetailLoading()) {
        <div class="flex items-center gap-2 text-xs text-slate-500">
          <i class="pi pi-spin pi-spinner"></i>
          Cargando detalle...
        </div>
      } @else if (matchCharge(); as charge) {
        <div class="flex items-start justify-between gap-2 mb-2">
          <div class="min-w-0">
            <p class="text-[0.65rem] uppercase tracking-wide text-slate-500">Recibo de Pento</p>
            <p class="text-sm font-semibold text-slate-900 truncate">{{ chargeCustomerName(charge) }}</p>
          </div>
          <div class="flex items-center gap-2 shrink-0">
            <span class="px-2 py-1 text-xs font-medium rounded-full bg-sky-100 text-sky-800">{{ chargeStatusLabel(charge.status) }}</span>
            @if (canUnmatch(selectedItem())) {
              <p-button
                label="Desemparejar"
                size="small"
                severity="warn"
                [loading]="isBusy(drawerKey(selectedItem()))"
                (onClick)="reverseSelected()"
                *appHasPermission="'BANK_RECONCILIATION_WRITE'" />
            }
          </div>
        </div>
        <div class="grid grid-cols-2 lg:grid-cols-4 gap-x-3 gap-y-1.5 text-left text-xs">
          <div>
            <p class="text-[0.65rem] text-slate-500">Monto</p>
            <p class="font-medium text-left">{{ charge.total | currency:'MXN':'symbol-narrow' }}</p>
          </div>
          <div>
            <p class="text-[0.65rem] text-slate-500">Vencimiento</p>
            <p class="font-medium text-left">{{ charge.dueDate || '-' }}</p>
          </div>
          <div>
            <p class="text-[0.65rem] text-slate-500">Fecha de pago</p>
            <p class="font-medium text-left">{{ charge.paidAt ? (charge.paidAt | date:'dd/MM/yyyy HH:mm') : 'Sin pago' }}</p>
          </div>
          <div>
            <p class="text-[0.65rem] text-slate-500">Parcialidad</p>
            <p class="font-medium text-left">{{ charge.paymentNumber || '-' }} / {{ charge.numberOfPayments || '-' }}</p>
          </div>
          <div>
            <p class="text-[0.65rem] text-slate-500">Venta</p>
            <p class="font-medium text-left truncate">{{ charge.sale?.number || (charge.sale?.id ? ('#' + charge.sale.id) : '-') }}</p>
          </div>
          <div>
            <p class="text-[0.65rem] text-slate-500">Referencia</p>
            <p class="font-medium text-left truncate">{{ selectedItem()?.label || charge.sale?.paymentReference || '-' }}</p>
          </div>
          @if (charge.payment; as payment) {
            <div>
              <p class="text-[0.65rem] text-slate-500">Forma de pago</p>
              <p class="font-medium text-left truncate">{{ paymentFormLabel(payment) }}</p>
            </div>
            <div>
              <p class="text-[0.65rem] text-slate-500">Banco del pago</p>
              <p class="font-medium text-left truncate">{{ payment.bank || '-' }}</p>
            </div>
            <div>
              <p class="text-[0.65rem] text-slate-500">Proveedor</p>
              <p class="font-medium text-left truncate">{{ paymentProviderLabel(payment) }}</p>
            </div>
            <div>
              <p class="text-[0.65rem] text-slate-500">Estado del pago</p>
              <p class="font-medium text-left truncate">{{ paymentStatusLabel(payment) }}</p>
            </div>
          } @else {
            <div class="col-span-2">
              <p class="text-[0.65rem] text-slate-500">Pago</p>
              <p class="font-medium text-left">Aún no tiene pago. Al conciliar se registrará.</p>
            </div>
          }
        </div>
      } @else if (matchSettlement(); as settlement) {
        <div class="mb-2 flex items-start justify-between gap-2">
          <div class="min-w-0">
            <p class="text-[0.65rem] uppercase tracking-wide text-slate-500">Liquidación de Pento</p>
            <p class="text-sm font-semibold text-slate-900">{{ settlement.transferBeneficiaryName || settlement.transferTrackCode || ('#' + settlement.id) }}</p>
          </div>
          @if (canUnmatch(selectedItem())) {
            <p-button
              label="Desemparejar"
              size="small"
              severity="warn"
              [loading]="isBusy(drawerKey(selectedItem()))"
              (onClick)="reverseSelected()"
              *appHasPermission="'BANK_RECONCILIATION_WRITE'" />
          }
        </div>
        <div class="grid grid-cols-2 lg:grid-cols-4 gap-x-3 gap-y-1.5 text-left text-xs">
          <div>
            <p class="text-[0.65rem] text-slate-500">Monto</p>
            <p class="font-medium text-left">{{ settlement.totalAmount | currency:'MXN':'symbol-narrow' }}</p>
          </div>
          <div>
            <p class="text-[0.65rem] text-slate-500">Fecha</p>
            <p class="font-medium text-left">{{ settlement.businessDate }}</p>
          </div>
          <div>
            <p class="text-[0.65rem] text-slate-500">Banco</p>
            <p class="font-medium text-left truncate">{{ settlement.transferBank || '-' }}</p>
          </div>
          <div>
            <p class="text-[0.65rem] text-slate-500">CLABE</p>
            <p class="font-medium text-left truncate">{{ settlement.transferClabe || '-' }}</p>
          </div>
          <div class="col-span-2">
            <p class="text-[0.65rem] text-slate-500">Clave de rastreo</p>
            <p class="font-medium text-left truncate">{{ settlement.transferTrackCode || '-' }}</p>
          </div>
          <div class="col-span-2">
            <p class="text-[0.65rem] text-slate-500">Concepto</p>
            <p class="font-medium text-left truncate">{{ settlement.transferConcept || '-' }}</p>
          </div>
        </div>
      } @else if (selectedItem(); as item) {
        <div class="grid grid-cols-2 lg:grid-cols-4 gap-x-3 gap-y-1.5 text-left text-xs">
          <div>
            <p class="text-[0.65rem] text-slate-500">Tipo</p>
            <p class="font-medium text-left">{{ kindLabel(item.kind) }}</p>
          </div>
          <div>
            <p class="text-[0.65rem] text-slate-500">Fecha</p>
            <p class="font-medium text-left">{{ item.date }}</p>
          </div>
          <div>
            <p class="text-[0.65rem] text-slate-500">Monto</p>
            <p class="font-medium text-left">{{ item.amount | currency:'MXN':'symbol-narrow' }}</p>
          </div>
          <div>
            <p class="text-[0.65rem] text-slate-500">Referencia</p>
            <p class="font-medium text-left truncate">{{ item.label || '-' }}</p>
          </div>
        </div>
      }
    </section>

    @if (selectedItem(); as item) {
      <div class="shrink-0 flex flex-wrap items-end justify-between gap-3">
        <p class="text-xs text-slate-600 m-0 pb-1">Abonos del CSV. Primero los recomendados; después el resto, por fecha.</p>
        <div class="flex items-end gap-3 ml-auto">
          <p-floatlabel variant="on">
            <p-select
              inputId="drawerAccount"
              [options]="drawerAccountOptions()"
              optionLabel="alias"
              optionValue="id"
              [ngModel]="drawerAccountId() ?? 0"
              (ngModelChange)="drawerAccountId.set($event || null)"
              appendTo="body"
              styleClass="w-56" />
            <label for="drawerAccount">Cuenta</label>
          </p-floatlabel>
          @if (!item.matched && item.suggestionActId) {
            <p-button label="Confirmar" size="small" (onClick)="confirm(item)" *appHasPermission="'BANK_RECONCILIATION_WRITE'" />
          }
        </div>
      </div>
      <div class="flex-1 min-h-0 overflow-hidden rounded-xl border border-slate-200 bg-white">
        <p-table
          [value]="displayMovements()"
          [loading]="loadingMovements()"
          [scrollable]="true"
          scrollHeight="flex"
          [rowHover]="true"
          styleClass="bank-candidates-table p-datatable-sm"
        >
          <ng-template pTemplate="header">
            <tr>
              <th></th>
              <th>Cuenta</th>
              <th class="text-center whitespace-nowrap">Fecha</th>
              <th class="text-right">Monto</th>
              <th class="hidden sm:table-cell">Descripción</th>
              <th>Referencia</th>
              <th class="hidden sm:table-cell">Clave de rastreo</th>
              <th class="hidden sm:table-cell">Banco ordenante</th>
              <th class="hidden sm:table-cell">Forma de pago</th>
              <th></th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-row>
            @if (separatorLabel(row); as label) {
              <tr
                [class.bg-sky-50]="label === 'Recomendados'"
                [class.bg-emerald-50]="label === 'Emparejados'"
                [class.bg-slate-100]="label === 'Ignorados'">
                <td colspan="10" class="!py-2">
                  <span
                    class="text-xs font-semibold uppercase tracking-wide"
                    [class.text-sky-800]="label === 'Recomendados'"
                    [class.text-emerald-800]="label === 'Emparejados'"
                    [class.text-slate-600]="label === 'Ignorados'">{{ label }}</span>
                </td>
              </tr>
            } @else if (movementFrom(row); as mov) {
              <tr [class.opacity-70]="isMatched(mov) || isIgnored(mov)">
                <td>
                  <div class="flex items-center gap-2">
                    <span
                      class="flex h-6 w-6 items-center justify-center rounded-md text-xs"
                      [ngClass]="isIgnored(mov) ? 'bg-slate-100 text-slate-500' : isMatched(mov) ? 'bg-emerald-100 text-emerald-700' : isCandidate(mov) ? 'bg-sky-100 text-sky-700' : 'bg-emerald-50 text-emerald-700'"
                    >
                      <i class="pi" [ngClass]="isIgnored(mov) ? 'pi-eye-slash' : isMatched(mov) ? 'pi-check' : isCandidate(mov) ? 'pi-sparkles' : 'pi-arrow-down-left'"></i>
                    </span>
                    @if (!isMatched(mov) && mismatchTooltip(mov); as tip) {
                      <i
                        class="pi pi-exclamation-triangle text-amber-500"
                        [pTooltip]="tip"
                        tooltipPosition="top"
                        appendTo="body"></i>
                    }
                  </div>
                </td>
                <td>
                  <span
                    class="text-xs font-medium text-slate-800"
                    [pTooltip]="accountTooltip(mov)"
                    tooltipStyleClass="account-tooltip"
                    tooltipPosition="top"
                    appendTo="body">{{ accountAlias(mov) }}</span>
                </td>
                <td class="text-center whitespace-nowrap" style="width: 6rem; min-width: 6rem">{{ mov.bookedAt }}</td>
                <td class="text-right">{{ mov.amount | currency:'MXN':'symbol-narrow' }}</td>
                <td class="hidden sm:table-cell">
                  <div class="truncate max-w-md">{{ mov.description }}</div>
                  @if (isIgnored(mov)) {
                    <p-tag class="!text-xs mt-1" severity="secondary" value="Ignorado" />
                  } @else if (isCandidate(mov)) {
                    <span class="text-xs text-sky-700">Candidato automático</span>
                  }
                </td>
                <td class="max-w-xs truncate">{{ mov.reference || '-' }}</td>
                <td class="hidden sm:table-cell max-w-xs truncate">{{ mov.trackCode || '-' }}</td>
                <td class="hidden sm:table-cell max-w-xs truncate">{{ mov.orderingBank || '-' }}</td>
                <td class="hidden sm:table-cell max-w-xs truncate">{{ movementPaymentFormLabel(mov) }}</td>
                <td class="text-right whitespace-nowrap">
                  @if (canUnmatchMovement(mov)) {
                    <p-button
                      label="Desemparejar"
                      size="small"
                      severity="warn"
                    [loading]="isBusy(movementKey(mov))"
                    (onClick)="unmatchMovement(mov)"
                      *appHasPermission="'BANK_RECONCILIATION_WRITE'" />
                  } @else if (canMatchMovement(mov)) {
                    <p-button
                      label="Conciliar"
                      size="small"
                      [loading]="isBusy(movementKey(mov))"
                      [disabled]="busyKey() != null"
                      (onClick)="matchSelected(mov)"
                      *appHasPermission="'BANK_RECONCILIATION_WRITE'" />
                    <p-button
                      label="Ignorar"
                      size="small"
                      [text]="true"
                      [disabled]="busyKey() != null"
                      (onClick)="ignore(mov)"
                      *appHasPermission="'BANK_RECONCILIATION_WRITE'" />
                  } @else if (isIgnored(mov)) {
                    <p-button
                      label="Reactivar"
                      size="small"
                      [text]="true"
                      [loading]="isBusy(reactivateKey(mov))"
                      (onClick)="reactivate(mov)"
                      *appHasPermission="'BANK_RECONCILIATION_WRITE'" />
                    <p-button
                      label="Eliminar"
                      size="small"
                      severity="danger"
                      [text]="true"
                      [loading]="isBusy(deleteKey(mov))"
                      (onClick)="deleteIgnored(mov)"
                      *appHasPermission="'BANK_RECONCILIATION_WRITE'" />
                  }
                </td>
              </tr>
            }
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="10" class="text-center text-slate-500 py-6 px-4">{{ emptyMatchHint() }}</td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    }
  </div>
</p-drawer>

<p-confirmDialog appendTo="body" />

<app-charge-read
  [charge]="selectedCharge()"
  [visible]="chargeReadOpen()"
  (visibleChange)="onChargeReadVisibleChange($event)" />

<p-dialog
  [visible]="payChargeDialogVisible()"
  (visibleChange)="!$event ? closePayChargeDialog() : payChargeDialogVisible.set($event)"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [dismissableMask]="!payChargeLoading()"
  [closable]="!payChargeLoading()"
  appendTo="body"
  [style]="{ width: 'min(28rem, calc(100vw - 2rem))' }"
  styleClass="[&_.p-dialog-footer]:!p-0"
  header="Registrar pago"
>
  <form [formGroup]="payChargeForm" class="flex flex-col gap-4 pt-1">
    <p class="text-sm text-slate-600 m-0">
      Registra el pago recibido para este recibo. Se creará el registro de pago y el intento asociado, y el movimiento quedará conciliado.
    </p>
    @if (payChargePaymentFormText(); as csvForm) {
      <p class="text-sm text-slate-600 m-0">
        El estado de cuenta indica la forma de pago «{{ csvForm }}».
      </p>
    }
    <p-floatlabel variant="on">
      <p-select
        formControlName="paymentFormId"
        inputId="reconcile-pay-payment-form"
        [options]="paymentFormOptions()"
        optionLabel="description"
        optionValue="id"
        placeholder="Selecciona una forma de pago"
        filter
        [showClear]="true"
        class="w-full"
        appendTo="body"
        [disabled]="payChargeLoading()"
      />
      <label for="reconcile-pay-payment-form">Forma de pago <span class="text-red-500">*</span></label>
    </p-floatlabel>
    <p-floatlabel variant="on">
      <input
        pInputText
        id="reconcile-pay-reference"
        class="w-full"
        formControlName="reference"
        maxlength="50"
        [disabled]="payChargeLoading()"
      />
      <label for="reconcile-pay-reference">Referencia <span class="text-red-500">*</span></label>
    </p-floatlabel>
    <p-floatlabel variant="on">
      <input
        pInputText
        id="reconcile-pay-bank"
        class="w-full"
        formControlName="bank"
        maxlength="255"
        [disabled]="payChargeLoading()"
      />
      <label for="reconcile-pay-bank">Banco</label>
    </p-floatlabel>
    <p-floatlabel variant="on">
      <textarea
        pTextarea
        id="reconcile-pay-description"
        formControlName="description"
        rows="3"
        [maxlength]="1000"
        fluid
        [disabled]="payChargeLoading()"
      ></textarea>
      <label for="reconcile-pay-description">Descripción</label>
    </p-floatlabel>
    <p-floatlabel variant="on">
      <p-datepicker
        formControlName="paymentDate"
        inputId="reconcile-pay-payment-date"
        [showTime]="true"
        hourFormat="24"
        dateFormat="dd/mm/yy"
        placeholder="dd/mm/aaaa hh:mm"
        fluid
        appendTo="body"
        [disabled]="payChargeLoading()"
      />
      <label for="reconcile-pay-payment-date">Fecha y hora de pago <span class="text-red-500">*</span></label>
    </p-floatlabel>
    <div class="flex items-center gap-2">
      <p-checkbox
        formControlName="sendReceiptEmail"
        inputId="reconcile-pay-send-receipt-email"
        [binary]="true"
        [disabled]="payChargeLoading()"
      />
      <label for="reconcile-pay-send-receipt-email" class="cursor-pointer select-none text-sm text-slate-700">
        Enviar correo de recibo de pago al cliente
      </label>
    </div>
  </form>
  <ng-template #footer>
    <div class="flex w-full items-center justify-end gap-2 border-t border-slate-200 bg-slate-50 px-6 pt-4 pb-4">
      <p-button
        label="Cancelar"
        severity="secondary"
        [text]="true"
        type="button"
        [disabled]="payChargeLoading()"
        (onClick)="closePayChargeDialog()"
      />
      <p-button
        label="Pagar y conciliar"
        icon="pi pi-check"
        type="button"
        [loading]="payChargeLoading()"
        appDisableUnless="CHARGE_WRITE"
        [disabled]="payChargeLoading() || payChargeForm.invalid"
        (onClick)="submitPayCharge()"
      />
    </div>
  </ng-template>
</p-dialog>

<p-dialog
  header="Importar CSV"
  [visible]="importDialog()"
  (visibleChange)="importDialog.set($event)"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [closable]="!importing()"
  [dismissableMask]="!importing()"
  appendTo="body"
  [style]="{ width: 'min(28rem, calc(100vw - 2rem))' }">
  <div class="flex flex-col gap-4 pt-1">
    <p class="text-sm text-slate-600 m-0">Elige la cuenta y el estado de cuenta en CSV.</p>
    <p-floatlabel variant="on">
      <p-select
        inputId="importAccount"
        [options]="accounts()"
        optionLabel="alias"
        optionValue="id"
        [ngModel]="importAccountId()"
        (ngModelChange)="importAccountId.set($event)"
        placeholder="Cuenta"
        appendTo="body"
        class="w-full"
        [disabled]="importing()" />
      <label for="importAccount">Cuenta</label>
    </p-floatlabel>
    <div class="flex items-center gap-3">
      <input #importCsvInput type="file" accept=".csv,text/csv" class="hidden" (change)="onImportFileSelected($event)" />
      <p-button label="Elegir archivo" icon="pi pi-file" size="small" severity="secondary" [disabled]="importing()" (onClick)="importCsvInput.click()" />
      <span class="text-sm text-slate-600 truncate">{{ importFileName() || 'Ningún archivo seleccionado' }}</span>
    </div>
    <div class="flex items-start gap-2">
      <p-checkbox
        inputId="replaceUnmatched"
        [binary]="true"
        [ngModel]="replaceUnmatched()"
        (ngModelChange)="replaceUnmatched.set($event)"
        [disabled]="importing()" />
      <label for="replaceUnmatched" class="text-sm text-slate-700 cursor-pointer">
        Sobrescribir los movimientos no conciliados de esta cuenta. Los que vienen en el archivo se actualizan, los que ya no vienen se borran y los conciliados se conservan.
      </label>
    </div>
  </div>
  <ng-template #footer>
    <div class="flex justify-end gap-2">
      <p-button label="Cancelar" severity="secondary" [text]="true" [disabled]="importing()" (onClick)="importDialog.set(false)" />
      <p-button label="Importar" icon="pi pi-upload" [loading]="importing()" [disabled]="importAccountId() == null || !importFileName()" (onClick)="submitImport()" />
    </div>
  </ng-template>
</p-dialog>

<p-dialog
  header="Resultado de la importación"
  [visible]="importResultDialog()"
  (visibleChange)="importResultDialog.set($event)"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  appendTo="body"
  [style]="{ width: 'min(28rem, calc(100vw - 2rem))' }">
  @if (importResult(); as result) {
    <div class="flex flex-col gap-3 text-sm text-slate-700">
      @if (result.error) {
        <p class="m-0 text-red-700">{{ result.error }}</p>
      } @else {
        <p class="m-0">El archivo se procesó.</p>
      }
      <p class="m-0"><span class="text-slate-500">Cuenta:</span> {{ result.account }}</p>
      <p class="m-0"><span class="text-slate-500">Archivo:</span> {{ result.file }}</p>
      @if (!result.error) {
        <p class="m-0"><span class="text-slate-500">Importados:</span> {{ result.inserted }}</p>
        <p class="m-0"><span class="text-slate-500">Omitidos:</span> {{ result.skipped }}</p>
        <p class="m-0"><span class="text-slate-500">Conciliados por clave de rastreo:</span> {{ result.matched }}</p>
      }
    </div>
  }
  <ng-template #footer>
    <div class="flex justify-end">
      <p-button label="Cerrar" (onClick)="importResultDialog.set(false)" />
    </div>
  </ng-template>
</p-dialog>

<p-dialog
  header="Ejecutar matching"
  [visible]="matchDialog()"
  (visibleChange)="matchDialog.set($event)"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [closable]="!matching()"
  [dismissableMask]="!matching()"
  appendTo="body"
  [style]="{ width: 'min(28rem, calc(100vw - 2rem))' }">
  <div class="flex flex-col gap-4 pt-1">
    <p class="text-sm text-slate-600 m-0">Elige la cuenta cuyos abonos se van a emparejar.</p>
    <p-floatlabel variant="on">
      <p-select
        inputId="matchAccount"
        [options]="accounts()"
        optionLabel="alias"
        optionValue="id"
        [ngModel]="matchAccountId()"
        (ngModelChange)="matchAccountId.set($event)"
        placeholder="Cuenta"
        appendTo="body"
        class="w-full"
        [disabled]="matching()" />
      <label for="matchAccount">Cuenta</label>
    </p-floatlabel>
  </div>
  <ng-template #footer>
    <div class="flex justify-end gap-2">
      <p-button label="Cancelar" severity="secondary" [text]="true" [disabled]="matching()" (onClick)="matchDialog.set(false)" />
      <p-button label="Ejecutar" icon="pi pi-bolt" [loading]="matching()" [disabled]="matchAccountId() == null" (onClick)="runMatch()" />
    </div>
  </ng-template>
</p-dialog>
